import { render, staticRenderFns } from "./SmartSearchAutocomplete.vue?vue&type=template&id=2b98cbe7"
import script from "./SmartSearchAutocomplete.vue?vue&type=script&lang=js"
export * from "./SmartSearchAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./SmartSearchAutocomplete.vue?vue&type=style&index=0&id=2b98cbe7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports